module.exports = __webpack_public_path__ + "img/iconbuhege.f02f1c18.png";